'use client';

import { ReactNode } from 'react';
import { HtmlMarkupRenderer } from './markup-renderer';
import { useProductTelemetryOnce } from '@/hooks/use-product-telemetry-once';

interface HtmlRendererProps {
  element: {
    props: {
      title?: string;
      html: string;
      css?: string;
      minHeight?: number;
      maxHeight?: number;
      showTitle?: boolean;
      fit?: 'auto' | 'contain';
      renderActions?: ReactNode;
      displayContext?: 'inline' | 'artifact';
    };
    visualizationId?: string;
  };
}

export function HtmlRenderer({ element }: HtmlRendererProps) {
  useProductTelemetryOnce(
    'visualization_render_failed',
    !element?.props?.html,
    {
      tool_name: 'html',
      failure_kind: 'missing-content',
      visualization_id: element?.visualizationId,
    },
    element?.visualizationId ?? 'missing-html-content',
  );

  if (!element?.props?.html) {
    return <div className="p-4 border rounded-lg bg-muted/30 text-muted-foreground">No HTML content provided</div>;
  }

  const { title, html, css, minHeight, maxHeight, showTitle, fit, renderActions, displayContext } = element.props;

  return (
    <HtmlMarkupRenderer
      title={title}
      markup={html}
      css={css}
      minHeight={minHeight}
      maxHeight={maxHeight}
      showTitle={showTitle}
      fit={fit}
      visualizationId={element.visualizationId}
      renderActions={renderActions}
      displayContext={displayContext}
    />
  );
}
